import { showOverlayAndSubmit } from "./common";

export function initTreeStats() {
	let popover_id: string | undefined;

	$(window).on('click', function () {
		if (popover_id != undefined) {
			$('#' + popover_id).popover('hide');
			console.log('Hiding:' + popover_id);
		}
	});

	$('.stat-event').on('click', function (e) {
		if (popover_id != undefined) {
			$('#' + popover_id).popover('hide');
			console.log('Hiding:' + popover_id);
		}
		var a_event = $(this);
		$.get(a_event.attr('data-details')!, function (d) {
			//console.log(d);
			a_event.popover({
				title: a_event.attr('data-project'),
				trigger: 'manual',
				placement: 'auto',
				content: d,
				container: 'body',
				html: true
			});
			a_event.popover('show');
			//console.log('Showing:' + a_event.attr('aria-describedby'));
			popover_id = a_event.attr('aria-describedby');
		});
	});


	$('.datetimepicker').datetimepicker().on('dp.change', function (ev) {
		//console.log('date changed: ' + ev.date);
		$('.r').submit();
	});

	$('.tree-toggler').on('click', function () {
		$(this).parent().children('.tree').toggle(300);
		if ($(this).find('.glyphicon:first').hasClass('glyphicon-triangle-right')) {
			$(this).find('.glyphicon:first').removeClass('glyphicon-triangle-right').addClass('glyphicon-triangle-bottom');
		} else {
			$(this).find('.glyphicon:first').removeClass('glyphicon-triangle-bottom').addClass('glyphicon-triangle-right');
		}
	});

	$('.r').on('submit', function () {
		$('#loaderoverlay').show();
		$('.loader').addClass('active');
	});

	function export_fmt(fmt: string) {
		const form = $('.r');
		const action = form.attr('action')!;
		form.attr('action', action + fmt);
		form.attr('target', "_blank");
		form.submit();
		form.attr('action', action);
		form.attr('target', null);
		$('#loaderoverlay').hide();
	}


	$('.export-pdf').on('click', function (e) {
		e.preventDefault();
		$('#r_detailed').val('0');
		export_fmt('.pdf');
	});
	$('.export-detailed-pdf').on('click', function (e) {
		e.preventDefault();
		$('#r_detailed').val('1');
		export_fmt('.pdf');
	});
	$('.export-csv').on('click', function (e) {
		e.preventDefault();
		export_fmt('.csv');
	});

	$('.refresh-stats').on('click', function (e) {
		e.preventDefault();
		showOverlayAndSubmit();
	});

	$('.period-selector').on('click', function () {
		if ($('#r_period').val() != $(this).data('period')) {
			$('#r_period').val($(this).data('period'));
		} else {
			$('#r_period').val('');
		}
		$('.r').submit();
	});

	$('#btnStepM').on('click', function (e) {
		$('#r_step').val('-');
		$('.r').submit();
	});

	$('#btnStepP').on('click', function (e) {
		$('#r_step').val('+');
		$('.r').submit();
	});
}